import type { ReactNode } from 'react';

export const getOptionLabelText = (label: ReactNode): string =>
    typeof label === 'string' ? label : '';
